import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.585 1.044C9.71.508 7.93 2.144 8.305 4.058l.574 2.935-3.004-.787-.078-.255a3.6 3.6 0 0 0-2.105-2.29A1.642 1.642 0 0 0 1.44 5.187v4.44c0 1.023.69 1.918 1.681 2.178l15.846 4.15c.84.22 1.735.072 2.46-.407 2.191-1.45 1.653-4.806-.882-5.497l-.252.926.252-.926-.176-.048-.01-.003-4.387-1.149-3.265-6.856a1.79 1.79 0 0 0-1.122-.95M10.188 3.69a.692.692 0 0 1 .813-.812l3.43 7.202.191.402.432.114 4.814 1.26.172.047c.942.257 1.142 1.504.328 2.043-.27.178-.602.233-.914.152L3.608 9.947l-.244.928.244-.929a.33.33 0 0 1-.248-.32V5.658c.283.212.496.51.601.854l.235.768.157.512.518.136 5.001 1.31 1.48.387-.294-1.5zM22.56 18.24H1.44a.96.96 0 1 0 0 1.92h21.12a.96.96 0 1 0 0-1.92m0 3.48H1.44a.96.96 0 1 0 0 1.92h21.12a.96.96 0 1 0 0-1.92",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }